import { translateObjectKeys, invertObject } from '../../../tools/object'
import RouteParser from '../../../tools/route-parser'
import REQUEST from '../types/request'

const { namespace, controller, action } = document.body.dataset

const state = {
  namespace,
  controller,
  action,
  route: {
    spec: '',
    abbrParamsMap: undefined,
    parserOptions: undefined
  },
  params: {},
  parser: undefined
}

const getters = {
  [REQUEST.GETTERS.GET_PARAMS]: state => {
    if (!state.parser) {
      return new RouteParser().toObject(location.pathname + location.search)
    }

    return state.params
  },
  [REQUEST.GETTERS.GET_NAMESPACE]: state => {
    return state.namespace
  },
  [REQUEST.GETTERS.GET_CONTROLLER]: state => {
    return state.controller
  },
  [REQUEST.GETTERS.GET_ACTION]: state => {
    return state.action
  },
  [REQUEST.GETTERS.GET_ROUTE]: state => {
    return state.route
  },
  [REQUEST.GETTERS.GET_PARSER]: state => {
    return state.parser
  }
}

const mutations = {
  [REQUEST.MUTATIONS.SET_PARAMS]: (state, payload) => {
    state.params = payload
  },
  [REQUEST.MUTATIONS.SET_ROUTE]: (state, payload) => {
    state.route = Object.assign({}, payload)
  },
  [REQUEST.MUTATIONS.SET_PARSER]: (state, payload) => {
    state.parser = payload
  }
}

const actions = {
  [REQUEST.ACTIONS.SETUP_ROUTE]: ({ state, commit, dispatch }, payload) => {
    commit(REQUEST.MUTATIONS.SET_ROUTE, payload)
    commit(REQUEST.MUTATIONS.SET_PARSER, new RouteParser(state.route.spec, state.route.parserOptions))
    dispatch(REQUEST.ACTIONS.PARSE_PARAMS)
  },
  [REQUEST.ACTIONS.PARSE_PARAMS]: ({ state, commit }) => {
    let params = state.parser.toObject(location.pathname + location.search)

    if (state.route.abbrParamsMap) {
      params = translateObjectKeys(params, invertObject(state.route.abbrParamsMap))
    }

    commit(REQUEST.MUTATIONS.SET_PARAMS, params)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
